export default {
  common: {
    close: 'Close',
    unlocked: 'Unlocked',
    confirm: 'Confirm',
    cancel: 'Cancel',
    all: 'All',
    locked: 'Locked',
    clickToSelect: 'Click'
  },

  game: {
    stats: {
      total: 'Total',
      combo: 'Combo',
      record: 'Record',
      days: 'Days'
    },
    currentType: 'Current Type',
    inUse: 'In Use',
    autoTap: 'Auto Tap',
    on: 'On',
    off: 'Off',
    clickToChangeType: 'Click to change blessing type',
    clickToChangeFish: 'Click to change mokugyo',
    selectType: 'Select Blessing Type',
    selectTypeDesc: 'Choose different types for different blessings',
    typeTips: 'Type Tips',
    typeTip1: 'Different types have different particle effects',
    typeTip2: 'Switching types won\'t affect combo and stats',
    typeTip3: 'Each type\'s tap count is calculated separately'
  },

  brand: {
    tagline: 'One Tap, One Prayer',
    company: 'Homy Tech Limited'
  },

  types: {
    merit: {
      name: 'Merit',
      description: 'Accumulate merit, purify mind'
    },
    love: {
      name: 'Love',
      description: 'Pray for romance, enhance relationships'
    },
    wealth: {
      name: 'Wealth',
      description: 'Attract fortune, prosper wealth'
    },
    health: {
      name: 'Health',
      description: 'Body and mind wellness, longevity'
    }
  },

  typeStats: {
    title: 'Tap Statistics',
    subtitle: 'View tap counts for each type',
    totalTaps: 'Total Taps',
    allTypes: 'All Types Combined',
    times: 'times',
    description: 'Type Total',
    tips: {
      title: 'Statistics Tips',
      tip1: 'Try different types for different blessing effects',
      tip2: 'Balance taps across types to unlock special achievements',
      tip3: 'Each type has unique particle effects and energy'
    }
  },

  achievements: {
    title: 'Achievements',
    subtitle: 'Record your spiritual journey',
    progress: 'Unlock Progress',
    filterByCategory: 'Filter by Category',
    unlocksFish: 'Unlocks Special Mokugyo',
    noResults: 'No matching achievements',
    allAchievements: 'All Achievements',
    unlockedAchievements: 'Unlocked',
    lockedAchievements: 'Locked',
    categories: {
      all: 'All',
      tap: 'Tap',
      combo: 'Combo',
      speed: 'Speed',
      type: 'Type',
      auto: 'Auto',
      special: 'Special'
    },
    rarity: {
      common: 'Common',
      uncommon: 'Uncommon',
      rare: 'Rare',
      epic: 'Epic',
      legendary: 'Legendary',
      mythic: 'Mythic'
    },
    tips: {
      title: 'Achievement Tips',
      tip1: 'Keep tapping to unlock more achievements',
      tip2: 'Try different tapping methods to discover hidden achievements',
      tip3: 'Some achievements unlock special mokugyo',
      tip4: 'Achievement progress is automatically saved'
    }
  },

  achievementsList: {
    first_tap: {
      title: 'First Step',
      description: 'First tap on mokugyo'
    },
    tap_100: {
      title: 'Sincere Heart',
      description: 'Total 100 taps'
    },
    tap_500: {
      title: 'Diligent Practice',
      description: 'Total 500 taps'
    },
    tap_1000: {
      title: 'Perseverance',
      description: 'Total 1,000 taps'
    },
    tap_5000: {
      title: 'Merit Complete',
      description: 'Total 5,000 taps'
    },
    tap_10000: {
      title: 'Unity of All',
      description: 'Total 10,000 taps'
    },
    tap_50000: {
      title: 'Practice Master',
      description: 'Total 50,000 taps'
    },
    tap_100000: {
      title: 'Immortal Legend',
      description: 'Total 100,000 taps'
    },
    combo_10: {
      title: 'Glimpse of Path',
      description: 'Achieve 10 combo'
    },
    combo_25: {
      title: 'Getting Better',
      description: 'Achieve 25 combo'
    },
    combo_50: {
      title: 'Undistracted Mind',
      description: 'Achieve 50 combo'
    },
    combo_100: {
      title: 'Focused Unity',
      description: 'Achieve 100 combo'
    },
    combo_200: {
      title: 'Heaven and Man Unite',
      description: 'Achieve 200 combo'
    },
    combo_500: {
      title: 'Transcendent',
      description: 'Achieve 500 combo'
    },
    combo_1000: {
      title: 'Eternal Strike',
      description: 'Achieve 1,000 combo'
    },
    speed_5: {
      title: 'Swift Hand',
      description: 'Tap within 0.5 seconds'
    },
    speed_3: {
      title: 'Fast as Wind',
      description: 'Tap within 0.2 seconds'
    },
    speed_1: {
      title: 'Lightning Reflex',
      description: 'Tap within 0.1 seconds'
    },
    perfect_rhythm: {
      title: 'Perfect Rhythm',
      description: '10 consecutive taps with 1-2 second intervals'
    },
    rhythm_master: {
      title: 'Rhythm Master',
      description: '30 consecutive taps with 1-2 second intervals'
    },
    type_master: {
      title: 'Type Master',
      description: 'Tap 50 times in each of 4 blessing types'
    },
    merit_devotee: {
      title: 'Merit Devotee',
      description: 'Merit mode total 500 times'
    },
    love_seeker: {
      title: 'Love Seeker',
      description: 'Love mode total 500 times'
    },
    wealth_collector: {
      title: 'Wealth Collector',
      description: 'Wealth mode total 500 times'
    },
    health_guardian: {
      title: 'Health Guardian',
      description: 'Health mode total 500 times'
    },
    buddha: {
      title: 'Buddha\'s Light',
      description: 'Merit mode total 1,000 times'
    },
    love_master: {
      title: 'Love Master',
      description: 'Love mode total 1,000 times'
    },
    wealth_tycoon: {
      title: 'Wealth Tycoon',
      description: 'Wealth mode total 1,000 times'
    },
    health_sage: {
      title: 'Health Sage',
      description: 'Health mode total 1,000 times'
    },
    merit_legend: {
      title: 'Merit Legend',
      description: 'Merit mode total 2,000 times'
    },
    love_legend: {
      title: 'Love Legend',
      description: 'Love mode total 2,000 times'
    },
    wealth_legend: {
      title: 'Wealth Legend',
      description: 'Wealth mode total 2,000 times'
    },
    health_legend: {
      title: 'Health Legend',
      description: 'Health mode total 2,000 times'
    },
    balanced_monk: {
      title: 'Balanced Monk',
      description: 'Each of 4 types reaches 100 times'
    },
    ultimate_devotion: {
      title: 'Ultimate Devotion',
      description: 'Each of 4 types reaches 500 times'
    },
    auto_beginner: {
      title: 'Auto Beginner',
      description: 'Enable auto tap'
    },
    auto_100: {
      title: 'Mechanical Helper',
      description: 'Auto tap total 100 times'
    },
    auto_1000: {
      title: 'Automation Master',
      description: 'Auto tap total 1,000 times'
    },
    auto_5000: {
      title: 'Mechanical Zen',
      description: 'Auto tap total 5,000 times'
    },
    auto_lover: {
      title: 'Automation Lover',
      description: 'Enable auto tap 10 times'
    },
    lazy_master: {
      title: 'Idle Master',
      description: 'Auto tap total 10,000 times'
    },
    night_owl: {
      title: 'Night Owl',
      description: 'Tap 50 times between 0-6 AM'
    },
    early_bird: {
      title: 'Early Bird',
      description: 'Tap 50 times between 6-9 AM'
    },
    midnight_devotion: {
      title: 'Midnight Devotion',
      description: 'Tap 200 times between 0-6 AM'
    },
    morning_blessing: {
      title: 'Morning Blessing',
      description: 'Tap 200 times between 6-9 AM'
    },
    session_100: {
      title: 'Single Session 100',
      description: 'Tap 100 times in one session'
    },
    session_500: {
      title: 'Session Frenzy',
      description: 'Tap 500 times in one session'
    },
    session_1000: {
      title: 'Single Session 1000',
      description: 'Tap 1,000 times in one session'
    },
    marathon: {
      title: 'Marathon Practice',
      description: 'Tap 2,000 times in one session'
    },
    steady_hand: {
      title: 'Steady Hand',
      description: '20 consecutive taps with 0.8-2 second intervals'
    },
    metronome: {
      title: 'Metronome',
      description: '10 consecutive taps with less than 0.1 second variance'
    },
    cat_lover: {
      title: 'Cat Friend',
      description: 'Total 2,000 taps'
    },
    rainbow_master: {
      title: 'Rainbow Cloud',
      description: 'Unlock 5 different mokugyo'
    },
    cosmic_collector: {
      title: 'Cosmic Truth',
      description: 'Reach 10,000 taps'
    },
    fish_collector: {
      title: 'Mokugyo Collector',
      description: 'Unlock all special mokugyo'
    },
    achievement_hunter: {
      title: 'Achievement Hunter',
      description: 'Unlock 20 achievements'
    },
    completionist: {
      title: 'Completionist',
      description: 'Unlock 40 achievements'
    },
    true_master: {
      title: 'True Master',
      description: 'Unlock all achievements'
    }
  },

  specialFish: {
    title: 'Special Mokugyo',
    subtitle: 'Collect and use special mokugyo',
    progress: 'Collection Progress',
    unlockCondition: 'Unlock Condition',
    howToUnlock: 'How to Unlock',
    description: 'Complete specific achievements to unlock special mokugyo, each with unique appearance',
    clickToSelect: 'Click to Select Mokugyo',
    clickToSelectDesc: 'Click any unlocked mokugyo card below to switch to that mokugyo. Selected mokugyo will show a ✓ mark.',
    types: {
      normal: {
        name: 'Normal Mokugyo',
        description: 'Basic mokugyo, brings good luck and peace',
        unlock: 'Unlocked by default'
      },
      golden: {
        name: 'Golden Mokugyo',
        description: 'Radiates wealth aura, increases fortune',
        unlock: 'Merit mode total 1,000 times'
      },
      crystal: {
        name: 'Crystal Mokugyo',
        description: 'Clear transparent crystal, purifies mind',
        unlock: 'Achieve 100 combo'
      },
      jade: {
        name: 'Jade Mokugyo',
        description: 'Symbolizes peace and longevity',
        unlock: 'Tap 50 times in each of 4 blessing types'
      },
      ruby: {
        name: 'Ruby Mokugyo',
        description: 'Full of passion, increases vitality',
        unlock: 'Tap within 0.2 seconds'
      },
      cat: {
        name: 'Cat Mokugyo',
        description: 'Cute cat-shaped mokugyo, makes meow sounds',
        unlock: 'Total 2,000 taps'
      },
      rainbow: {
        name: 'Rainbow Mokugyo',
        description: 'Gorgeous rainbow mokugyo, brings happiness',
        unlock: 'Unlock 5 different mokugyo'
      },
      cosmic: {
        name: 'Cosmic Mokugyo',
        description: 'Contains infinite cosmic energy',
        unlock: 'Reach 10,000 taps'
      }
    }
  },

  help: {
    title: 'Game Guide',
    tabs: {
      gameplay: 'How to Play',
      types: 'Types',
      fish: 'Mokugyo',
      achievements: 'Achievements',
      tips: 'Tips'
    },
    gameplay: {
      step1: {
        title: 'Tap Mokugyo',
        description: 'Tap the mokugyo in the center'
      },
      step2: {
        title: 'Accumulate Energy',
        description: 'Each tap increases corresponding type energy'
      },
      step3: {
        title: 'Continuous Tapping',
        description: 'Tap within 2 seconds for combo bonus'
      },
      step4: {
        title: 'Auto Tap',
        description: 'Enable auto tap for automatic tapping'
      }
    },
    controls: {
      title: 'Controls',
      mouse: 'Mouse Click',
      touch: 'Touch Screen',
      keyboard: 'Space Key'
    },
    fish: {
      description: 'Complete specific achievements to unlock special mokugyo',
      level: {
        common: 'Common',
        rare: 'Rare',
        epic: 'Epic',
        legendary: 'Legendary'
      }
    },
    achievements: {
      description: 'Complete various challenges to unlock achievement rewards',
      achievements: 'achievements',
      rarity: 'Rarity Levels'
    },
    tips: {
      tip1: {
        title: 'Keep Rhythm',
        description: 'Stable tapping rhythm achieves higher combos'
      },
      tip2: {
        title: 'Try Speed',
        description: 'Fast tapping unlocks speed-related achievements'
      },
      tip3: {
        title: 'Use Auto',
        description: 'Auto tap is suitable for long practice sessions'
      },
      tip4: {
        title: 'Collect Mokugyo',
        description: 'Unlock all special mokugyo for extra rewards'
      },
      tip6: {
        title: 'Switch Types',
        description: 'Try different types for different blessings'
      }
    },
    shortcuts: {
      title: 'Shortcuts',
      space: 'Tap Mokugyo',
      esc: 'Close Modal'
    }
  },

  donation: {
    title: 'Support Us',
    subtitle: 'Your support is our greatest motivation',
    message: 'If you enjoy this game, please consider supporting us to develop more interesting features',
    oneTime: 'One-Time',
    oneTimeDesc: 'One-time support',
    monthly: 'Monthly',
    monthlyDesc: 'Continuous support',
    selectAmount: 'Select Amount',
    perMonth: 'per month',
    donateButton: 'Proceed to Payment',
    selectAmountFirst: 'Please select amount',
    thankYou: 'Thank you for your donation',
    footerNote: 'All donations will be used for game development and maintenance',
    paymentMethod: 'Payment Method',
    securePayment: 'Secure Stripe Payment System',
    supportCards: 'Supports Credit & Debit Cards',
    instantProcess: 'Instant Processing, Safe & Reliable',
    poweredByStripe: 'Powered by Stripe - Secure Payment System',
    paymentPageOpened: 'Payment page opened. Please complete payment in the new window.',
    benefits: {
      title: 'Supporter Benefits',
      benefit1: 'Receive our eternal gratitude',
      benefit2: 'Support continuous game development',
      benefit3: 'May receive special rewards in the future'
    }
  }
};